interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({
  message = 'Route wird berechnet …',
}: LoadingScreenProps): JSX.Element {
  return (
    <div className="flex min-h-full items-center justify-center bg-slate-50 p-8">
      <div className="flex flex-col items-center gap-6">
        <svg
          width="200"
          height="130"
          viewBox="0 0 200 130"
          fill="none"
          aria-label="Lädt"
          role="img"
        >
          {/* Karten-Gitter (Andeutung) */}
          <g stroke="#e2e8f0" strokeWidth="0.5">
            <line x1="0" y1="25" x2="200" y2="25" />
            <line x1="0" y1="60" x2="200" y2="60" />
            <line x1="0" y1="95" x2="200" y2="95" />
            <line x1="35" y1="0" x2="35" y2="130" />
            <line x1="85" y1="0" x2="85" y2="130" />
            <line x1="135" y1="0" x2="135" y2="130" />
            <line x1="180" y1="0" x2="180" y2="130" />
          </g>

          {/* Gestrichelte Hintergrund-Route */}
          <path
            d="M 25 95 C 55 95, 70 60, 100 60 S 140 25, 175 25"
            stroke="#cbd5e1"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="2 4"
            fill="none"
          />

          {/* Aktive Route – wird sich aufbauend animiert */}
          <path
            d="M 25 95 C 55 95, 70 60, 100 60 S 140 25, 175 25"
            stroke="#0f172a"
            strokeWidth="2.5"
            strokeLinecap="round"
            fill="none"
            strokeDasharray="220"
            strokeDashoffset="220"
          >
            <animate
              attributeName="stroke-dashoffset"
              from="220"
              to="0"
              dur="2.2s"
              repeatCount="indefinite"
            />
          </path>

          {/* Start-Pin mit Puls-Ring */}
          <g>
            <circle cx="25" cy="95" r="6" fill="#0f172a" opacity="0.25">
              <animate attributeName="r" values="6;15;6" dur="2.2s" repeatCount="indefinite" />
              <animate
                attributeName="opacity"
                values="0.35;0;0.35"
                dur="2.2s"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="25" cy="95" r="5" fill="#0f172a" />
            <circle cx="25" cy="95" r="2" fill="#ffffff" />
          </g>

          {/* Ziel-Pin mit verzögertem Puls */}
          <g>
            <circle cx="175" cy="25" r="6" fill="#0f172a" opacity="0.25">
              <animate
                attributeName="r"
                values="6;15;6"
                dur="2.2s"
                begin="1.1s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="opacity"
                values="0.35;0;0.35"
                dur="2.2s"
                begin="1.1s"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="175" cy="25" r="5" fill="#0f172a" />
            <circle cx="175" cy="25" r="2" fill="#ffffff" />
          </g>

          {/* Fahrzeug-Punkt fährt entlang der Route */}
          <circle r="4" fill="#16a34a" stroke="#ffffff" strokeWidth="1.5">
            <animateMotion
              dur="2.2s"
              repeatCount="indefinite"
              path="M 25 95 C 55 95, 70 60, 100 60 S 140 25, 175 25"
            />
          </circle>
        </svg>

        {/* H&R Logo */}
        <div className="flex items-center gap-3">
          <div
            className="flex h-9 w-9 items-center justify-center rounded-md bg-brand-ink text-xs font-semibold text-white"
            style={{ letterSpacing: 0.5 }}
          >
            H&amp;R
          </div>
          <div className="h-8 w-px bg-brand-line" aria-hidden="true" />
          <div className="flex flex-col leading-tight">
            <span
              className="text-[13px] font-medium text-brand-ink"
              style={{ letterSpacing: '0.15em' }}
            >
              HANDEL
            </span>
            <span
              className="text-[9px] font-light text-brand-muted"
              style={{ letterSpacing: '0.25em' }}
            >
              FAHRTENPLANER
            </span>
          </div>
        </div>

        {/* Blinkende Lade-Punkte */}
        <div className="flex items-center gap-1.5" aria-hidden="true">
          <span
            className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand-muted"
            style={{ animationDelay: '0s' }}
          />
          <span
            className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand-muted"
            style={{ animationDelay: '0.15s' }}
          />
          <span
            className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand-muted"
            style={{ animationDelay: '0.3s' }}
          />
        </div>

        <p className="text-xs text-brand-muted">{message}</p>
      </div>
    </div>
  );
}
